import React from "react";
import logo from "../../assets/Background.png";
import CTA from "../cta/cta";
import { useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

// Function to handle scrolling to sections
const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
        section.scrollIntoView({ behavior: "smooth" });
    }
};

const Header = () => {
    const location = useLocation();
    const isHomePage = location.pathname !== "/";
    const isDonatePage = location.pathname === "/donate";
    const isConsolePage = location.pathname === "/console";
    const isConsoleLoginPage = location.pathname === "/console/login";
    const isEventsPage = location.pathname === "/events" || location.pathname === "/online-ticket";
    const isAppreciationPage = location.pathname === "/appreciation";

    return (
        <>

            {!isConsolePage && !isConsoleLoginPage && (
                <div className="fixed top-0 flex items-center justify-center w-full z-[1000]">
                    <div className="flex justify-between items-center p-[10px] bg-[linear-gradient(to_bottom,#ffffffFF_0%,#ffffffF0_25%,#ffffffBF_50%,#ffffff80_71%,#ffffff40_87%,#ffffff00_100%)] rounded-none w-full mt-0  min-[1608px]:w-full">

                        {!isHomePage && (
                            <>
                                <div onClick={() => scrollToSection('hero')} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: "10px", color: 'white' }}>
                                    <div className="h-[50px] w-[50px]">
                                        <img src={logo} alt="Logo" className="h-[50px] w-[50px]" />
                                    </div>

                                </div>
                                <div className="flex justify-center flex-row items-center gap-[20px]">
                                    <div className="flex justify-center items-center gap-[20px]">
                                        <a className="hidden min-[908px]:inline-block min-[908px]:bg-transparent min-[908px]:border-none min-[908px]:text-black min-[908px]:text-[12px] min-[908px]:cursor-pointer" href="/events"><button className="hidden min-[908px]:inline-block min-[908px]:bg-transparent min-[908px]:border-none min-[908px]:text-black min-[908px]:text-[12px] min-[908px]:cursor-pointer"><b>Events</b></button></a>
                                        <button className="hidden min-[908px]:inline-block min-[908px]:bg-transparent min-[908px]:border-none min-[908px]:text-black min-[908px]:text-[12px] min-[908px]:cursor-pointer" onClick={() => scrollToSection('about')}><b>About</b></button>
                                        <button className="hidden min-[908px]:inline-block min-[908px]:bg-transparent min-[908px]:border-none min-[908px]:text-black min-[908px]:text-[12px] min-[908px]:cursor-pointer" onClick={() => scrollToSection('partners')}><b>Partners</b></button>
                                        <a className="hidden min-[908px]:inline-block min-[908px]:bg-transparent min-[908px]:border-none min-[908px]:text-black min-[908px]:text-[12px] min-[908px]:cursor-pointer" href="/appreciation"><button className="hidden min-[908px]:inline-block min-[908px]:bg-transparent min-[908px]:border-none min-[908px]:text-black min-[908px]:text-[12px] min-[908px]:cursor-pointer"><b>Appreciation</b></button></a>
                                    </div>
                                    {!isDonatePage &&
                                        <CTA />}
                                </div>
                            </>
                        )}
                        {isHomePage && !isConsolePage && !isConsoleLoginPage && (
                            <>
                                <a href="/" style={{ textDecoration: 'none' }} className="flex items-center gap-5">
                                    <div onClick={() => scrollToSection('hero')} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: "10px", color: 'white' }}>
                                        <div className="h-[50px]">
                                            <img src={logo} alt="Logo" className="h-[50px]" />
                                        </div>

                                    </div>
                                    <div className="flex items-center gap-0">
                                        <ChevronLeft />
                                        <p className="font-bold">
                                            Back
                                        </p>
                                    </div>
                                </a>
                                {!isDonatePage && !isEventsPage && !isAppreciationPage &&
                                    <CTA />}
                            </>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default Header;
